import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Box, Button } from '@mui/material'
import { Body1, H3 } from '../../../../layouts/TextStyles'
import StartExamDialog from '../../../../components/dialogs/StartExamDialog'
import {
    SectionDetailsState,
    SectionState,
    UserTopicState,
} from '../../../../features/types'

interface Props {
    section: SectionState
    topic: UserTopicState
    sectionDetails: SectionDetailsState
}

const styles = {
    wrapper: {
        display: 'grid',
        gridTemplateColumns: 'auto',
        gap: '16px',
        justifyContent: 'start',
        mb: 8,
    },
    flex: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}

const QuizContent: React.FC<Props> = ({ section, sectionDetails }) => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()

    const [openDialog, setOpenDialog] = useState(false)

    const handleClose = () => {
        setOpenDialog(false)
    }

    return (
        <Box sx={styles.wrapper}>
            <H3>{section.title}</H3>

            <Body1>
                {formatMessage({ id: 'numberOfQuestions' })}:{' '}
                {sectionDetails.countQuestions}
            </Body1>

            <Body1>
                {formatMessage({ id: 'duration' })}: {sectionDetails.duration}
            </Body1>

            <Box>
                <Box sx={{ mb: 2 }}>
                    {formatMessage({ id: 'testResult' })} - {section.percentage}
                    %
                </Box>

                <Button
                    style={{ color: '#ffffff' }}
                    variant="contained"
                    color="secondary"
                    onClick={() =>
                        navigate(`/teacher-courses/exam-result/${section.id}`)
                    }
                >
                    {formatMessage({ id: 'openTest' })}
                </Button>
            </Box>

            {/* <Button
                variant="contained"
                onClick={() => setOpenDialog(true)}
            >
                {formatMessage({ id: 'start' })}
            </Button> */}

            {/* <Box sx={styles.flex}>
                <Box>1 {formatMessage({ id: 'exam_results' })} - 10%</Box>

                <IconButton onClick={() => navigate('/my-courses/exam-result')}>
                    <DocumentScanner />
                </IconButton>
            </Box>

            <Box sx={styles.flex}>
                <Box>2 {formatMessage({ id: 'exam_results' })} - 10%</Box>

                <IconButton onClick={() => navigate('/my-courses/exam-result')}>
                    <DocumentScanner />
                </IconButton>
            </Box>

            <Box sx={styles.flex}>
                <Box>3 {formatMessage({ id: 'exam_results' })} - 10%</Box>

                <IconButton onClick={() => navigate('/my-courses/exam-result')}>
                    <DocumentScanner />
                </IconButton>
            </Box> */}

            <StartExamDialog
                title={section.title}
                open={openDialog}
                handleClose={handleClose}
                confirmAction={() => navigate('/exam')}
            />
        </Box>
    )
}

export default QuizContent
